import { Reveal } from "@/components/Reveal";
import { Chapter } from "@/components/Chapter";
import { FaqAccordion } from "@/components/FaqAccordion";

export const FaqSection = () => (
  <section id="faq" data-testid="section-faq" className="bg-paper py-24 md:py-32 border-t border-ink/10">
    <div className="mx-auto max-w-5xl px-5 md:px-8">
      <Reveal>
        <Chapter number="04" kicker="FAQ" title="Domande frequenti sul medico competente" />
      </Reveal>
      <Reveal delay={0.1}>
        <FaqAccordion />
      </Reveal>
    </div>
  </section>
);
